import { Carousel } from "../carousel/carousel.model";
import { Category } from "../model/category";
import { OrderPortalProduct } from "../model/product";
import { Company } from "../state/companies/company.model";
import { Order } from "../state/orders/order.model";
import { Role } from "../state/roles/role.model";

export const e2eCompany: Company = {
  id: "e2e-company",
  name: "E2E Company",
  logo: "office.jpg",
  test: true
};

export const e2eRole: Role = {
  id: "e2e-role",
  name: "E2E Portal Role",
  company: e2eCompany.id,
  companyName: e2eCompany.name,
  quota: 100,
  test: true
};

export const e2eCategories: Category[] = [
  {
    id: "workwear",
    name: "Workwear",
    path: "workwear",
    image: "tradies.jpg",
    order: 0
  },
  {
    id: "office",
    name: "Office",
    path: "office",
    image: "office.jpg",
    order: 1
  },
  {
    id: "empty-category",
    name: "Empty Category",
    path: "empty-category",
    image: "school.jpg",
    order: 2
  },
  {
    id: "workwear-hi-vis",
    name: "Hi-Vis",
    path: "hi-vis",
    parentPath: "workwear",
    image: "categories/WORKWEAR HI VIS.jpg",
    order: 0
  }
];

export const e2eProducts: OrderPortalProduct[] = [
  {
    id: "3948",
    code: "3948",
    brand: "DNC",
    name: "HiVis 3 Way Shirt",
    sizes: "XS-6XL",
    fabric: "155gsm lightweight cotton",
    image: "tradies.jpg",
    extraImages: ["office.jpg"],
    sourceUrl: "https://www.dncworkwear.com.au/Product/3948",
    features: ["Under arm cotton mesh vents", "Upper back cotton mesh vent"],
    hints: ["hivis", "cotton", "shirt"],
    relatedStyles: ["K54820"],
    demographic: ["Mens"],
    colours: ["Yellow/Navy", "Orange/Navy"],
    publicWebsite: true,
    category: "workwear/hi-vis",
    created: 1700000000000,
    updated: 1700000000000,
    price: 30,
    type: "Shirts",
    description: "Fixture product used by Playwright smoke tests.",
    roles: []
  },
  {
    id: "K54820",
    code: "K54820",
    brand: "Bisley Workwear",
    name: "Cool Lightweight Shirt",
    sizes: "S-5XL",
    fabric: "Cotton drill",
    image: "office.jpg",
    extraImages: [],
    features: ["Lightweight fabric"],
    hints: ["workwear", "shirt"],
    relatedStyles: ["3948"],
    demographic: ["Mens"],
    colours: ["Navy"],
    publicWebsite: true,
    category: "workwear/hi-vis",
    created: 1700000000001,
    updated: 1700000000001,
    price: 35,
    type: "Shirts",
    description: "Second fixture product for category and related product checks.",
    roles: []
  },
  {
    id: "E2E-POLO",
    code: "E2E-POLO",
    brand: "Fixture Brand",
    name: "Portal Polo",
    sizes: "S-XL",
    fabric: "Cotton blend",
    image: "office.jpg",
    extraImages: [],
    features: ["Fixture-only portal product"],
    hints: ["portal", "polo"],
    relatedStyles: [],
    demographic: ["Mens"],
    colours: ["Navy"],
    publicWebsite: false,
    category: "portal",
    created: 1700000000002,
    updated: 1700000000002,
    price: 42,
    type: "Mens Polo",
    description: "Fixture product used by Playwright admin report tests.",
    roles: [e2eRole.id]
  }
];

export const e2eCarousels: Carousel[] = [
  {
    id: "e2e-carousel",
    alt: "Playwright fixture carousel",
    src: "tradies.jpg",
    heading: "E2E Workwear",
    subtitle: "Fixture-backed storefront smoke test",
    href: "/category/workwear",
    order: 0
  }
];

const fixtureOrderDate = {
  seconds: Math.floor(Date.UTC(2026, 0, 15, 4, 30) / 1000),
  nanoseconds: 0
} as any;

export const e2eOrders: Order[] = [
  {
    id: "e2e-order-paid",
    userId: "e2e-customer",
    email: "customer@example.com",
    company: e2eCompany.name,
    companyId: e2eCompany.id,
    role: e2eRole.name,
    roleId: e2eRole.id,
    name: "Pat Customer",
    phone: "0400000000",
    comments: "Leave at reception",
    reference: "PO-123",
    items: [
      {
        code: "E2E-POLO",
        product: {
          code: "E2E-POLO",
          brand: "Fixture Brand",
          name: "Portal Polo",
          image: "office.jpg",
          description: "Fixture product used by Playwright admin report tests.",
          type: "Mens Polo",
          price: 42,
          embroideryPrice: 0
        },
        sizes: [
          { size: "M", colour: "Navy", amount: 2 },
          { size: "L", colour: "Navy", amount: 1 }
        ],
        embroideredName: "PAT",
        price: 42,
        total: 126
      }
    ],
    total: 126,
    orderDate: fixtureOrderDate,
    status: "Paid",
    test: false,
    personal: false,
    showStudentNameField: false
  },
  {
    id: "e2e-order-voided",
    userId: "e2e-customer",
    email: "voided@example.com",
    company: e2eCompany.name,
    companyId: e2eCompany.id,
    role: e2eRole.name,
    roleId: e2eRole.id,
    name: "Voided Customer",
    items: [
      {
        code: "E2E-POLO",
        product: {
          code: "E2E-POLO",
          brand: "Fixture Brand",
          name: "Portal Polo",
          image: "office.jpg",
          description: "Fixture product used by Playwright admin report tests.",
          type: "Mens Polo",
          price: 42,
          embroideryPrice: 0
        },
        sizes: [{ size: "S", colour: "Navy", amount: 1 }],
        price: 42,
        total: 42
      }
    ],
    total: 42,
    orderDate: fixtureOrderDate,
    status: "Voided",
    test: false,
    personal: false,
    showStudentNameField: false
  }
];
